var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6364 24H4.36364C1.95382 24 0 22.0462 0 19.6364V4.36364C0 1.95382 1.95382 0 4.36364 0H19.6364C22.0462 0 24 1.95382 24 4.36364V19.6364C24 22.0462 22.0462 24 19.6364 24Z",
    fill: "#067BC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31397 11.6516L10.3495 15.2257L17.3877 8.82937",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox-active.4b7f2c6f3b0a811e413e00cdea6813cf.svg";
export { ForwardRef as ReactComponent };